import React, {FC, useEffect, useRef, useState} from 'react';

interface Props extends React.ImgHTMLAttributes<HTMLImageElement> {
  src: string | undefined;
  srcSet?: string;
  sizes?: string;
  alt?: string;
  lazy?: boolean;
  delayLoading?: boolean;
}

const BaseImage: FC<Props> = ({src, srcSet, sizes, alt, lazy = true, delayLoading = false, ...other}) => {
  const imgRef = useRef<HTMLImageElement>(null);
  const [isVisible, setIsVisible] = useState(!delayLoading);

  useEffect(() => {
    if (!delayLoading || !imgRef.current) return;
    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          setIsVisible(true);
          observer.disconnect();
        }
      },
      {rootMargin: '600px 0px'},
    );
    observer.observe(imgRef.current);
    return () => observer.disconnect();
  }, [delayLoading]);

  return (
    <img
      ref={imgRef}
      src={isVisible ? src : undefined}
      srcSet={isVisible ? srcSet : undefined}
      sizes={isVisible ? sizes : undefined}
      decoding='async'
      alt={alt}
      loading={!delayLoading || lazy ? 'lazy' : 'eager'}
      {...other}
    />
  );
};

export default BaseImage;
